<button class="hamburger hamburger--slider" [class.is-active]="active" [class.contrast]="contrast" type="button">
  <span class="hamburger-box">
    <span class="hamburger-inner"></span>
  </span>
</button>